/**
 * Checks if a set of cards contains a wordId
 *
 * @param cards {Array} - An array of cards from a deck
 * @param wordId {Integer} - Word Id as a number
 * @return {Boolean} - Returns a boolean
 */

export default (cards, wordId) => {
  return cards.some(el => {
    return +el.word_id === +wordId;
  });
};



// WEBPACK FOOTER //
// ./src/utils/cardsArrayContainsWord.js